import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-kpi-details-dialog',
  imports: [MatDialogModule],
  templateUrl: './kpi-details-dialog.component.html',
  styleUrl: './kpi-details-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KpiDetailsDialogComponent {
  title = input.required<string>();
  subtitle = input<string | null>(null);
}
